"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LinkField = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _ErrorHandlingFormHelperText = _interopRequireDefault(require("../ErrorHandlingFormHelperText"));

var _Validations = _interopRequireDefault(require("../Validations"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EnhancedTextInput = (0, _Validations.default)(_TextInput.default);

var LinkField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LinkField, _Component);

  var _super = _createSuper(LinkField);

  function LinkField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkField);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (event, field) {
      var newState = _objectSpread(_objectSpread({}, _this.state), {}, (0, _defineProperty2.default)({}, field, field === "openInNewWindow" ? event.target.checked : event.target.value));

      _this.setState(_objectSpread({}, newState), function () {
        var _this$state = _this.state,
            url = _this$state.url,
            displayName = _this$state.displayName,
            openInNewWindow = _this$state.openInNewWindow;
        _this.props.onChange && _this.props.onChange(event, {
          url: url,
          displayName: displayName,
          openInNewWindow: openInNewWindow
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$state2 = _this.state,
          url = _this$state2.url,
          displayName = _this$state2.displayName,
          openInNewWindow = _this$state2.openInNewWindow;
      var _this$props = _this.props,
          label = _this$props.label,
          helperText = _this$props.helperText,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          required = _this$props.required,
          id = _this$props.id;
      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        className: "prmbl-linkField",
        id: id,
        container: true,
        spacing: 1
      }, /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        id: id ? "".concat(id, "-linkField-label") : undefined
      }, label), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(EnhancedTextInput, {
        id: "".concat(id, "linkField-url"),
        onChange: function onChange(e) {
          return _this.onChange(e, "url");
        },
        disabled: _this.props.disabled,
        value: url,
        className: "prmbl-linkField-url",
        label: "URL",
        error: error,
        required: required
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: id ? "".concat(id, "-linkField-displayName") : undefined,
        onChange: function onChange(e) {
          return _this.onChange(e, "displayName");
        },
        value: displayName,
        disabled: _this.props.disabled,
        className: "prmbl-linkField-displayName",
        label: "Display Name"
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
        id: id ? "".concat(id, "-openInNewWindowFormControlLabel") : undefined,
        label: "Open in new window",
        value: "Open in new window",
        control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          id: id ? "".concat(id, "-linkField-openInNewWindow") : undefined,
          onChange: function onChange(e) {
            return _this.onChange(e, "openInNewWindow");
          },
          className: "prmbl-linkField-openInNewWindow",
          disabled: _this.props.disabled,
          checked: openInNewWindow
        })
      })), /*#__PURE__*/_react.default.createElement(_ErrorHandlingFormHelperText.default, {
        id: id ? "".concat(id, "-linkField-errorHandlerText") : undefined,
        helperText: helperText,
        error: error,
        errorMessage: errorMessage
      }));
    });
    _this.state = {
      url: _this.props.url || "",
      displayName: _this.props.displayName || "",
      openInNewWindow: _this.props.openInNewWindow || false
    };
    return _this;
  }

  return LinkField;
}(_react.Component);

exports.LinkField = LinkField;
(0, _defineProperty2.default)(LinkField, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The text to be displayed above the Text Inputs as the label
   */
  label: _propTypes.default.string,

  /**
   * The text inside the URL field.
   */
  url: _propTypes.default.string,

  /**
   * The text inside the Display Name field.
   */
  displayName: _propTypes.default.string,

  /**
   * Whether or not when the URL is clicked if it should open the link in a new window, or open it in the current window.
   */
  openInNewWindow: _propTypes.default.bool,

  /**
   * Function to be called when one of the fields change.
   */
  onChange: _propTypes.default.func,

  /**
   * Text to be shown at the bottom of the component to give the user an idea of how to use the fields.
   */
  helperText: _propTypes.default.string,

  /**
   * If true, the URL field will light up red, and display the errorMessage prop.
   */
  error: _propTypes.default.bool,

  /**
   * Will be used in place of the helperText if the error prop is true.
   */
  errorMessage: _propTypes.default.string,

  /**
   * If true, thr URL field will display an asterisk next to the label.
   */
  required: _propTypes.default.bool,

  /**
   * If the field should be disabled
   */
  disabled: _propTypes.default.bool
});
var _default = LinkField;
exports.default = _default;